<template>
  <div
    v-if="isActive"
    class="multimedia__content-scroll">
    <p v-if="total > 0" class="multimedia__content-total">
      <span>Total :</span>{{ total }}
    </p>
    <vue-scroll ref="scroll" @handle-scroll="handleScroll">
      <empty-multinedia :icon="icon" v-if="!showLoader && !hasMultimediaTab"/>
      <slot v-else></slot>
    </vue-scroll>
    <chat-loader v-if="showLoader"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EventBus from '@/eventBus';
import { USER_MULTIMEDIA_LOAD, USER_MULTIMEDIA_LOAD_STATUS } from '@/eventTypes';

export default {
  props: {
    icon: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    selected: {
      default: false,
      type: Boolean,
    },
    clientId: {
      type: String,
      required: true,
    },
    channelId: {
      type: String,
      required: true,
    },
    title: String,
  },
  components: {
    ChatLoader: () => import('@/components/ChatLoader.vue'),
    EmptyMultinedia: () => import('@/components/userMultimedia/EmptyMultimedia.vue'),
  },
  data() {
    return {
      isActive: false,
      scrollTop: 0,
      scrollHeight: 0,
      scrollProcess: 0,
      showLoader: false,
    };
  },
  computed: {
    ...mapGetters([
      'multimediaLastId',
      'getUserMultimedia',
      'hasMultimedia',
    ]),
    hasIcon() {
      return this.icon !== '';
    },
    currentLastId() {
      return this.multimediaLastId(this.clientId, this.name);
    },
    multimedia() {
      return this.getUserMultimedia(this.clientId, this.name) ?? {};
    },
    total() {
      return this.multimedia.total ?? 0;
    },
    hasMultimediaTab() {
      return this.hasMultimedia(this.clientId, this.name);
    },
    totalFetched() {
      return this.hasMultimediaTab ? Object.keys(this.multimedia.multimedia)
        .reduce((acc, value) => acc + this.multimedia.multimedia[value].length, 0) : 0;
    },
    reachedTotal() {
      return this.total !== this.totalFetched;
    },
  },
  watch: {
    scrollProcess(newVal) {
      if (newVal === 1 && this.reachedTotal && !this.showLoader) {
        this.loadMultimedia(this.clientId);
      }
    },
    'multimedia.multimedia': function hideLoader() {
      this.showLoader = false;
    },
  },
  created() {
    EventBus.$on(USER_MULTIMEDIA_LOAD_STATUS, ({ type, notEmpty }) => {
      if (!notEmpty && type === this.name) {
        this.showLoader = false;
      }
    });
  },
  mounted() {
    if (!this.hasMultimediaTab) {
      this.loadMultimedia(this.clientId);
    }

    this.isActive = this.selected;
  },
  destroyed() {
    EventBus.$off(USER_MULTIMEDIA_LOAD_STATUS);
  },
  methods: {
    handleScroll(v) {
      this.scrollProcess = v.process;
    },
    loadMultimedia(clientId) {
      this.showLoader = true;

      EventBus.$emit(USER_MULTIMEDIA_LOAD, {
        clientId,
        type: this.name,
        lastId: this.currentLastId,
        channelId: this.channelId,
      });
    },
  },
};
</script>
